import '../styles/CV.css';
import CVSummary from './CVSummary';
import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import ExhibitionList from './ExhibitionList';
import UpcomingExhibitionList from './UpcomingExhibitionList';

function CV({ visible, onClose }) {
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [spatialExhibitions, setSpatialExhibitions] = useState([]);
    const [soloExhibitions, setSoloExhibitions] = useState([]);
    const [groupExhibitions, setGroupExhibitions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [bio, setBio] = useState('');
    
    useEffect(() => {
        async function fetchData() {
            try {
                // Fetch bio from texts table
                const { data: bioData, error: bioErr } = await supabase
                    .from('texts')
                    .select('text')
                    .eq('name', 'cv-bio')
                    .single();
                
                if (bioErr && bioErr.code !== 'PGRST116') throw bioErr;
                const bioText = bioData?.text || '';
                setBio(bioText);

                // Fetch upcoming events from events table
                const { data: eventsData, error: eventsErr } = await supabase
                    .from('events')
                    .select('*')
                    .order('order', { ascending: true, nullsFirst: false })
                    .order('date', { ascending: true });
                
                if (eventsErr) throw eventsErr;
                setUpcomingEvents(eventsData || []);

                // Fetch CV projects ordered by the order column
                const { data: cvProjectsData, error: cvErr } = await supabase
                    .from('cv-projects')
                    .select('id, title, category, project_id, external_url, order')
                    .order('order', { ascending: true, nullsFirst: false })
                    .order('id', { ascending: false });

                if (cvErr) throw cvErr;

                // Transform CV projects into exhibition items
                const cvProjects = cvProjectsData || [];
                const spatial = cvProjects
                    .filter(p => p.category === 'spatial')
                    .map(p => ({ 
                        label: p.title, 
                        url: p.external_url ? p.external_url : (p.project_id ? `/exhibitions/${p.project_id}` : null),
                        external: !!p.external_url,
                    }));
                const solo = cvProjects
                    .filter(p => p.category === 'solo')
                    .map(p => ({ 
                        label: p.title, 
                        url: p.external_url ? p.external_url : (p.project_id ? `/exhibitions/${p.project_id}` : null),
                        external: !!p.external_url,
                    }));
                const group = cvProjects
                    .filter(p => p.category === 'group')
                    .map(p => ({ 
                        label: p.title, 
                        url: p.external_url ? p.external_url : (p.project_id ? `/exhibitions/${p.project_id}` : null),
                        external: !!p.external_url,
                    }));

                setSpatialExhibitions(spatial);
                setSoloExhibitions(solo);
                setGroupExhibitions(group);
            } catch (err) {
                console.error('Error fetching CV data:', err);
            } finally {
                setLoading(false);
            }
        }
        
        fetchData();
    }, []);
    
    if (!visible) return null;
    
    if (loading) return <div>Loading...</div>;

    const containerStyle = {
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
    };

    const hasBio = bio.trim().length > 0;

    return (
        <div className="cv-overlay" onClick={onClose}>
            <div className="cv-modal" onClick={e => e.stopPropagation()} style={containerStyle}>

                {hasBio && <CVSummary bio={bio} />}

                <div style={{ gridColumn: 2, gridRow: 1 }}>
                    <UpcomingExhibitionList events={upcomingEvents} />
                </div>

                <div style={{ gridColumn: 1, gridRow: hasBio ? 2 : '1 / span 2', paddingTop: hasBio ? 0 : 8 }}>
                    <ExhibitionList title="Spatial" items={spatialExhibitions} />
                    <br />
                    <ExhibitionList title="Solo Exhibitions" items={soloExhibitions} />
                </div>

                <div style={{ gridColumn: 2, gridRow: 2 }}>
                    <ExhibitionList title="Group Exhibitions" items={groupExhibitions} />
                </div>
                
            </div>
        </div>
    );
}

export default CV;
